import React from 'react';


export const LandingWellness = ({ navigate }) => (
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm font-semibold mb-4">
              🌿 Holistic Healing
            </div>
            <h2 className="font-heading text-4xl font-bold text-gray-900 mb-4">
              Complete Your Recovery with Ayurveda & Yoga
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Combine modern treatment with India's ancient wellness traditions for faster healing and lasting health
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Ayurveda Card */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-green-100 hover:border-green-300 transition-all">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center text-3xl">
                  🌿
                </div>
                <div>
                  <h3 className="font-heading text-2xl font-bold text-gray-900 mb-2">
                    Ayurveda Treatments
                  </h3>
                  <p className="text-gray-600">5,000-year-old healing science for modern recovery</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-3 mb-6">
                {[
                  { name: 'Panchakarma', icon: '🍃' },
                  { name: 'Abhyanga Massage', icon: '💆' },
                  { name: 'Shirodhara', icon: '🪔' },
                  { name: 'Herbal Therapy', icon: '🌺' }
                ].map((treatment, idx) => (
                  <div key={idx} className="flex items-center gap-2 p-3 bg-green-50 rounded-xl">
                    <span className="text-xl">{treatment.icon}</span>
                    <span className="text-sm font-medium text-gray-700">{treatment.name}</span>
                  </div>
                ))}
              </div>

              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  Body detoxification & rejuvenation
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  Natural pain management
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  Stress relief & mental clarity
                </li>
              </ul>
            </div>

            {/* Yoga Card */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-green-100 hover:border-green-300 transition-all">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl flex items-center justify-center text-3xl">
                  🧘
                </div>
                <div>
                  <h3 className="font-heading text-2xl font-bold text-gray-900 mb-2">
                    Therapeutic Yoga
                  </h3>
                  <p className="text-gray-600">Gentle practices tailored for post-surgical recovery</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-3 mb-6">
                {[
                  { name: 'Hatha Yoga', icon: '🧘' },
                  { name: 'Pranayama', icon: '🌬️' },
                  { name: 'Meditation', icon: '🕉️' },
                  { name: 'Yoga Nidra', icon: '✨' }
                ].map((program, idx) => (
                  <div key={idx} className="flex items-center gap-2 p-3 bg-teal-50 rounded-xl">
                    <span className="text-xl">{program.icon}</span>
                    <span className="text-sm font-medium text-gray-700">{program.name}</span>
                  </div>
                ))}
              </div>

              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  Faster post-surgery recovery
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  Improved flexibility & strength
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-600">
                  <span className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                  Mental peace & emotional healing
                </li>
              </ul>
            </div>
          </div>

          {/* Wellness Packages Preview */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-green-100 mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">Popular Wellness Packages</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { name: '7-Day Recovery Retreat', price: '$1,200', duration: '7 days' },
                { name: '14-Day Healing Program', price: '$2,200', duration: '14 days', popular: true },
                { name: '21-Day Transformation', price: '$3,500', duration: '21 days' }
              ].map((pkg, idx) => (
                <div key={idx} className={`p-6 rounded-2xl border-2 ${pkg.popular ? 'border-green-500 bg-green-50' : 'border-gray-200'} text-center relative`}>
                  {pkg.popular && (
                    <span className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-green-500 text-white text-xs px-3 py-1 rounded-full">
                      Most Popular
                    </span>
                  )}
                  <h4 className="font-semibold text-gray-900 mb-2">{pkg.name}</h4>
                  <p className="text-2xl font-bold text-green-600 mb-1">{pkg.price}</p>
                  <p className="text-sm text-gray-500">{pkg.duration}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={() => navigate('/wellness')}
              className="px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-semibold text-lg hover:shadow-xl transition-all inline-flex items-center gap-2"
            >
              Explore Wellness Programs
              <span>→</span>
            </button>
          </div>
        </div>
      </section>
);
